const Icon = ({ iconId, ...rest }) => {
  const ariaLabel = rest['aria-label']
  const ariaDescribedBy = rest['aria-describedby']
  const ariaHidden = !(ariaLabel || ariaDescribedBy)
  const role = ariaLabel || ariaDescribedBy ? null : 'presentation'

  return (
    <svg
      className={`icon ${iconId}`}
      role={role}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      data-contrast="svg-fill"
      {...rest}
    >
      <use xlinkHref={`#${iconId}`} />
    </svg>
  )
}

export default Icon
